import script from "./FacilityIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilityIcon.vue?vue&type=script&setup=true&lang=js"

import "./FacilityIcon.vue?vue&type=style&index=0&id=fe4c1e84&lang=css"

const __exports__ = script;

export default __exports__